import { Box, Card, List, Title } from '@nimbus-ds/components';
import { useTranslationDashboard } from 'domains/Dashboard/hooks';
import boldLogo from './bold-logo.svg';

export function BoldProjectAffiliateDiscountAlert() {
  const t = useTranslationDashboard('trialMessages.bold');

  return (
    <Box paddingBottom="5">
      <Card>
        <Card.Body>
          <Box display="flex" flexDirection="row" gap="6">
            <Box
              padding="2"
              paddingLeft="2"
              paddingRight="2"
              borderRadius="base"
              backgroundColor="neutral-surface"
              display="flex"
              justifyContent="center"
              height="40px"
            >
              <img src={boldLogo} alt="" style={{ height: '24px' }} />
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              gap="4"
              justifyContent="center"
            >
              <Box display="flex" flexDirection="column" gap="2">
                <Title as="h6">{t('title')}</Title>
                <List as="ul">
                  <List.Item>{t('one')}</List.Item>
                  <List.Item>{t('two')}</List.Item>
                  <List.Item>{t('three')}</List.Item>
                </List>
              </Box>
            </Box>
          </Box>
        </Card.Body>
      </Card>
    </Box>
  );
}
